export const data = () => ({
    nbUser: 15,
    newCapacity: 1,
    proration: null,
    prorationLoader: false,
    checkedPricingType: false,
    taxeRateObject: null,
});
export default {
    data,
    mounted() {
        this.getTaxRateObject();
    },
    computed: {
        priceVOOffer() {
            if (this.plan && this.plan.interval === "yearly") {
                return this.plan.price * 12;
            } else {
                return this.plan.price;
            }
        },
        calculateEventOneDayPricing() {
            return this.nbUser * this.plan.price;
        },
        newCalculateEventOneDayPricing() {
            return this.newCapacity * this.plan.price;
        },
        calculateEventPricing() {
            return this.nbUser * this.plan.price;
        },
        calculateEventPricingToPay() {
            return this.nbUser * this.plan.price;
        },
        newCalculateEventPricing() {
            return this.newCapacity * this.plan.price;
        },
        newCalculateEventPricingToPay() {
            return this.newCapacity * this.plan.price;
        },
        calculateVoPricing() {
            return this.nbUser * this.plan.price;
        },
        calculateVoPricingToPay() {
            return this.nbUser * this.priceVOOffer;
        },
        calculateVoPricingSimulatorToPay() {
            return this.nbUser * this.plan.price * (this.checkedPricingType ? 12 : 1);
        },
        newCalculateVoPricing() {
            return this.newCapacity * this.plan.price;
        },
        newCalculateVoYearPricing() {
            return this.newCapacity * this.plan.price * 12;
        },
        proratesDue() {
            if (!this.proration || this.proration.amount_due === 0) {
                return 0;
            }
            const due = (this.proration.lines.data[0].amount + this.proration.lines.data[1].amount) / 100;
            if (!this.currentDiscount) {
                return due;
            }
        },
        proratesVatDue() {
            if (!this.proration || this.proration.amount_due === 0) {
                return 0;
            }
            return (
                (this.proration.lines.data[0].tax_amounts[0].amount +
                    this.proration.lines.data[1].tax_amounts[0].amount) /
                100
            );
        },
        nextPaymentProrationDate() {
            return moment.unix(this.proration.subscription_proration_date).format("dddd, MMMM Do YYYY");
        },
        taxRate(){
            if(
                this.taxeRateObject == undefined || 
                this.taxeRateObject == undefined || 
                this.taxeRateObject.percentage == undefined || 
                this.taxeRateObject?.percentage === 0
            ){
                return 0;
            }
            return this.taxeRateObject.percentage / 100;
        }
    },
    methods: {
        calculateProration() {
            this.prorationLoader = true;
            axios
                .get(
                    `/settings/${Spark.teamsPrefix}/${this.team.id}/subscription/${this.teamSubscribeId}/proration/${this.newCapacity}`
                )
                .then((response) => {
                    this.proration = response.data;
                    this.prorationLoader = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.prorationLoader = false;
                });
        },
        // Get tax rate object from Stripe
        getTaxRateObject() {
            axios
                .get(
                    `/settings/${Spark.teamsPrefix}/${this.team.id}/taxerate/${this.plan.attributes.tax_rates[0]}`
                )
                .then((response) => {
                    this.taxeRateObject = response.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    },
};
